import { QualtricsCookies } from "../components/Common/constants";
export function doesQualtricsCookieExist(cookieName) {
    const currentCookies = decodeURIComponent(document.cookie);
    const splitCurrentCookies = currentCookies.split(';');
    for (const currentFocusedCookie of splitCurrentCookies) {
        if (currentFocusedCookie.includes(cookieName)) {
            return true;
        }
    }
    return false;
}
export function getQualtricsCookieValue(cookieName) {
    const currentCookies = decodeURIComponent(document.cookie);
    const splitCurrentCookies = currentCookies.split(';');
    for (const currentFocusedCookie of splitCurrentCookies) {
        if (currentFocusedCookie.includes(cookieName)) {
            return currentFocusedCookie.trim().substring(cookieName.length, currentFocusedCookie.length);
        }
    }
}
export function setQualtricsCookieValue(props) {
    const cookieExpirationDate = new Date();
    cookieExpirationDate.setTime(cookieExpirationDate.getTime() + (2 * 24 * 60 * 60 * 1000));
    const expireTime = "expires=" + cookieExpirationDate.toUTCString();
    document.cookie = props.CookieName + props.Type + ";" + expireTime + ";path=/";
}
export function deleteQualtricsCookie() {
    document.cookie = `${QualtricsCookies.HadLiveChat}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `${QualtricsCookies.SYFIVA}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `${QualtricsCookies.IVALaunchType}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
export function updateQualtricsCookieValue(cookieName, value) {
    const props = {
        CookieName: cookieName,
        Type: value,
    };
    if (doesQualtricsCookieExist(cookieName) === false) {
        setQualtricsCookieValue(props);
    }
    else {
        if (getQualtricsCookieValue(cookieName) !== value) {
            setQualtricsCookieValue(props);
        }
    }
}
